import { useSelector } from 'react-redux';
import { useFullstory } from 'data-ops-fullstory';
import { Text } from 'foundations-components/components/Text';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped
import NotificationList from 'ReduxMessenger/components/NotificationList';
import ContextualTrialPrompt from 'trial-components-library/trial/prompts/ContextualTrialPromptContainer';
import { useWootricSurvey } from './hooks/useWootricSurvey';
import { getHasForecastingAccess } from './selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Application = ({
  children
}) => {
  const hasForecastingAccess = useSelector(getHasForecastingAccess);

  // Can trigger local FullStory events via `window.setFullstoryDebugMode(true)` in debug console
  useFullstory({
    appKey: 'Forecasting'
    // the following allows the tracking the status of variables (such as gates) in fullStory
    // identifyVariables: { features: { exampleValueFromSelector } },
  });
  useWootricSurvey();
  if (!hasForecastingAccess) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "keys",
      illustrationProps: {
        width: 200
      },
      title: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "index.errorMessage.title"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "index.errorMessage.description"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(ContextualTrialPrompt, {
      app: "forecasting"
    })]
  });
};
export default Application;